export default __webpack_public_path__ + "static/media/exclamation-circle-light.b20d57dd.svg";